"use client"

import type { CodexTab } from "@/hooks/use-codex-state"

interface CodexTabNavigationProps {
  activeTab: CodexTab
  onTabChange: (tab: CodexTab) => void
}

const tabs: Array<{ id: CodexTab; label: string }> = [
  { id: "towers", label: "Towers" },
  { id: "enemies", label: "Enemies" },
  { id: "items", label: "Items" },
]

export const CodexTabNavigation = ({
  activeTab,
  onTabChange,
}: CodexTabNavigationProps) => {
  return (
    <div
      id="codex-tab-navigation"
      className="flex border-b border-amber-600/30 bg-black/30"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 py-3 px-4 text-sm font-bold transition-colors relative ${
              isActive
                ? "text-amber-300 bg-amber-900/20"
                : "text-gray-400 hover:text-gray-200 hover:bg-white/5"
            }`}
          >
            {tab.label}
            {/* Active indicator underline */}
            {isActive && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-amber-500" />
            )}
          </button>
        )
      })}
    </div>
  )
}
